import React, { useState, useRef } from "react";
import { navigate } from "@reach/router";
import { withStyles } from "@material-ui/core/styles";
import { API } from "aws-amplify";
import { Formik } from "formik";
import * as Yup from "yup";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { MenuItem } from "@material-ui/core";

import Snackbar from "../../../../components/Snackbar";
import Loader from "../../Loader";
import {
  messagefnSwitcher,
  messageSwitcher
} from "../../../../utils/formHelper";

const styles = theme => ({
  container: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#fefefe",
    width: 500
  },
  formElement: {
    margin: theme.spacing.unit
  }
});

const renderMessage = (message, messageFunc, variant) => {
  if (!message) {
    return "";
  }
  return (
    <Snackbar
      message={message}
      onClose={() => messageFunc(null)}
      open={Boolean(message)}
      variant={variant}
    />
  );
};


const TranslatorForm = ({ classes, survey, jwtToken }) => {
  const [loader, setLoader] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const localesValues = ["en", "es", "ja", "ko", "pt", "ru", "tw", "vi", "zh"];
  const statusMessage = "translating...";
  const [successMessage, setSuccessMessage] = useState(null);
  const fileRef = useRef();
  const translateQuestionare = async data => {
    setLoader(true);
    try {
      await API.put(
        "surveys",
        `/surveys/${survey._id}/translator/locale/${data.locale}`,
        {
          body: {
            ...data
          },
          headers: { Authorization: `Bearer ${jwtToken}` }
        }
      );
      setLoader(false);
      setSuccessMessage("translated successfully");
      navigate(`/admin/surveys/${survey.name}`);
    } catch (error) {
      setLoader(false);
      setErrorMessage(error.message);
    }
  };

  const onFilesChange = (event, setFieldValuefn) => {
    try {
      const fileReader = new FileReader();
      fileReader.readAsText(event.target.files[0], "UTF-8");
      fileReader.onload = e => {
        const jsonValue = JSON.parse(e.target.result);
        setFieldValuefn("translatorContent", jsonValue);
      };
    } catch (error) {
      console.log("error", error);
      return;
    }
  };

  return (
    <>
      <Loader loader={loader} message={statusMessage} />

      <Formik
        enableReinitializing
        initialValues={{
          translatorContent: "",
          locale: localesValues[0]
        }}
        validationSchema={Yup.object().shape({
          translatorContent: Yup.string().required("file is required"),
          locale: Yup.string().required("locale is missing")
        })}
        onSubmit={(values, { resetForm }) => {
          translateQuestionare(values);
          resetForm();
          fileRef.current.value = "";
        }}
        render={({
          values,
          handleChange,
          errors,
          touched,
          handleSubmit,
          setFieldValue
        }) => (
          <form className={classes.container} noValidate autoComplete="off">
            <TextField
              name="locale"
              label="locale"
              select={true}
              value={values.locale}
              onChange={handleChange}
              helperText={errors.locale}
              margin="normal"
              className={classes.formElement}
              InputLabelProps={{
                shrink: true
              }}
            >
              {localesValues.map((type_, idx) => (
                <MenuItem key={idx} value={type_}>
                  {type_}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              name="translatorContent"
              lable="content file"
              type="file"
              inputRef={fileRef}
              error={errors.translatorContent && touched.translatorContent}
              onChange={value => {
                onFilesChange(value, setFieldValue);
              }}
              className={classes.formElement}
              helperText={errors.translatorContent}
            />

            <Button
              variant="contained"
              color="primary"
              className={classes.formElement}
              onClick={handleSubmit}
            >
              translate
            </Button>
          </form>
        )}
      />
      {renderMessage(
        errorMessage || successMessage,
        messagefnSwitcher(
          errorMessage,
          successMessage,
          setErrorMessage,
          setSuccessMessage
        ),
        messageSwitcher(errorMessage)
      )}
    </>
  );
};

export default withStyles(styles)(TranslatorForm);
